export default "__VITE_ASSET__WyfKPVrq__"